// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Login_wrapper__2K8zU","container":"Login_container__4sPfA","btnLink":"Login_btnLink__3EYg4"};